import { UNKNOWN_WARNING, warningSentence } from '../i18n/ca-warnings';

/**
 * One of the generator's warnings as a person reads it. A key the web app has
 * no sentence for is never printed as the sentence: a neutral line says there
 * is something, with the key in small print for whoever reports it.
 */
export function WarningLine({ code }: { code: string }) {
  const text = warningSentence(code);
  if (text !== null) return <>{text}</>;
  return (
    <>
      {UNKNOWN_WARNING} <small className="muted warning-key">({code})</small>
    </>
  );
}
